import { message } from 'antd';
import { makeObservable, observable, action, computed, runInAction } from 'mobx';
import { Router, VerificationType } from 'src/constants';
import UserService from 'src/services/user';
import infoStore from 'src/stores/infoStore';
import { passwordValidator } from 'src/utils';

export default class ResetPwdVM {
  @observable isLoading = false;
  @observable password;
  @observable passwordConfirm;
  router;

  constructor(router) {
    makeObservable(this);
    this.router = router;
  }

  didMount = () => {};


  resetPwd = async () => {
    const isValid = passwordValidator(this.password);
    if (!isValid) {
      infoStore.show({
        message: '密碼至少八碼，英文字母及數字至少各一碼',
        type: 'warn'
      });
      return;
    }


    if (this.password !== this.passwordConfirm) {
      message.error('密碼不一致，請重新確認');
      return;
    }


    try {
      runInAction(() => { this.isLoading = true; });
      await UserService.resetPassword(this.password);
      runInAction(() => { this.isLoading = false; });

      message.success('密碼重設成功！');
      this.router.navigate(Router.Client.Profile);


    } catch (err) {
      runInAction(() => { this.isLoading = false; });
      let _message = '';
      switch (err?.response?.status) {
        case 401:
          _message = '帳號未登入';
          break;
        case 400:
          _message = '帳號至少八碼，英文字母及數字至少各一碼';
          break;
        default:
          _message = '發生錯誤';
      }
      infoStore.show({ message: _message, type: 'warn' });
    }
  };

  @action onPasswordChange = (e) => {
    this.password = e.target.value;
  };
  @action onPasswordConfirmChange = (e) => {
    this.passwordConfirm = e.target.value;
  };
}
